import { Box, Typography } from '@customink/pigment-react';
import { useProduct } from '@customink/project-service-react-components';
import type {
  Complement,
  ProjectItem,
} from '@customink/project-service-react-components';

import ComplementsGrid from './ComplementsGrid';

import { colorLightGrey, spacing16 } from '@/utils/designTokens';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const defaultEmptyHandler = () => {};

type ComplementsBoxProps = {
  onAddCompatible: () => void;
  onSelectComplement: (complement: Complement) => void;
  projectItems: ProjectItem[];
};

export default function ComplementsBox({
  onAddCompatible = defaultEmptyHandler,
  onSelectComplement = defaultEmptyHandler,
  projectItems,
}: ComplementsBoxProps) {
  const { data: anchorProduct } = useProduct({
    colorId: projectItems[0].product?.colorId,
  });
  const hasCompatibleProducts = !!anchorProduct?.compatible_type;

  return (
    <>
      <Box
        data-testid="complements-header"
        sx={{
          backgroundColor: colorLightGrey,
          padding: spacing16,
        }}
      >
        <Typography fontWeight="bold" variant="bodyLong2">
          Add a product
        </Typography>
        {' | '}
        <Typography variant="bodyShort1">
          Browse and apply your design to more products
        </Typography>
      </Box>
      <Box
        data-testid="complements-box"
        sx={{
          padding: '0px 16px 16px',
          backgroundColor: colorLightGrey,
        }}
      >
        <ComplementsGrid
          onAddCompatible={onAddCompatible}
          onSelectComplement={onSelectComplement}
          projectItems={projectItems}
          showCatalogCard={hasCompatibleProducts}
        />
      </Box>
    </>
  );
}
